export { DashboardResolver } from './dashboard.resolver';
